import React, { useEffect, useState } from "react"
import TextBox from 'devextreme-react/text-box';
import { CheckBox, TextArea } from 'devextreme-react';
import SelectBox from "../../../../common/CustomSelectBox";
import DateBox from "../../../../common/CustomDateBox";
import { SubstitutionVehicleTemplateTypes } from "../../../../../Constantes/documentataionRequestTypes";
import { useDispatch, useSelector } from "react-redux";
import { deleteStrangeCharacters } from "../../../../../commonFunctions/commonFunctions";
import { getTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/thunks";
import { selectTaxonomyTemplates, selectTaxonomyTemplatesLoading } from "../../../../../redux/factoryProcessTemplates/selectors";
import dayjs from "dayjs";
import { selectFactoryProvinces, selectFactoryProvincesLoading, selectFactoryProvincesWithOffices, selectFactoryProvincesWithOfficesLoading } from "../../../../../redux/factoryProvinces/selectors";
import { getFactoryProvinces, getFactoryProvincesWithOffices } from "../../../../../redux/factoryProvinces/thunks";
import { getFactoryCities } from "../../../../../redux/factoryCities/thunks";
import { selectFactoryCities } from "../../../../../redux/factoryCities/selectors";
import {selectFactoryOfficesByCity, selectFactoryOfficesByProvince } from "../../../../../redux/factoryOffices/selectors"
import {getFactoryOfficesByCityId, getFactoryOfficesByProvinceId } from "../../../../../redux/factoryOffices/thunks"
import { getFactoryRentTypes } from "../../../../../redux/factoryRentTypes/thunks";
import { selectFactoryRentTypes, selectFactoryRentTypesLoading } from "../../../../../redux/factoryRentTypes/selectors";
import { getFactoryChannels } from "../../../../../redux/factoryChannels/thunks";
import { selectFactoryChannels, selectFactoryChannelsLoading } from "../../../../../redux/factoryChannels/selectors";
import { getFactoryCategories } from "../../../../../redux/factoryCategories/thunks";
import { selectFactoryCategories, selectFactoryCategoriesLoading } from "../../../../../redux/factoryCategories/selectors";
import { selectFactoryTypes, selectFactoryTypesLoading } from "../../../../../redux/factoryTypes/selectors";
import { getFactoryTypes } from "../../../../../redux/factoryTypes/thunks";
import { getFactoryBranches } from "../../../../../redux/factoryBranches/thunks";
import { selectContract } from "../../../../../redux/contract/selectors";
import { selectFactoryBranches } from "../../../../../redux/factoryBranches/selectors";
import { factoryActive } from "../../../../../Constantes/factoryActive";
import { getFactoryCategoriesSVUnlimited } from "../../../../../redux/factoryCategoriesSVUnlimited/thunks";
import { openModal } from "../../../../../redux/modal/modalSlice";
import { getFactoryModalityBag, getFactoryModalityPool, getFactoryModalityTypeDaysYear } from "../../../../../redux/factoryBagGroups/thunks";
import { selectFactoryBagGroups } from "../../../../../redux/factoryBagGroups/selectors";
import { Divider } from "@material-ui/core";
import { selectWorkshopSearchResults } from "../../../../../redux/workshopSearch/selectors";

function SubstitutionVehicleRequestForm(props){
const {classes, onChange, dataForm, template} = props;
const dispatch = useDispatch();
const types = useSelector(selectTaxonomyTemplates);
const typesLoading = useSelector(selectTaxonomyTemplatesLoading)
const [type, setType] = useState(dataForm?.templateCode)
const {plate} = useSelector(selectContract);
const {customerCode} = useSelector(selectContract);
const [officeSchedules, setOfficeSchedules] = useState({});
const provincesWithOffices = useSelector(selectFactoryProvincesWithOffices);
const allProvinces = useSelector(selectFactoryProvinces);
const cities = useSelector(selectFactoryOfficesByProvince);
const allCities = useSelector(selectFactoryCities);
const officesByCity = useSelector(selectFactoryOfficesByCity);
const rentTypes = useSelector(selectFactoryRentTypes)
const channels = useSelector(selectFactoryChannels)
const categories = useSelector(selectFactoryCategories)
const typesInfo = useSelector(selectFactoryTypes)
const branches = useSelector(selectFactoryBranches)
const groups = useSelector(selectFactoryBagGroups)
const provincesWithOfficesLoading = useSelector(selectFactoryProvincesWithOfficesLoading)
const provincesLoading = useSelector(selectFactoryProvincesLoading)
const rentTypesLoading = useSelector(selectFactoryRentTypesLoading)
const channelsLoading = useSelector(selectFactoryChannelsLoading)
const categoriesLoading = useSelector(selectFactoryCategoriesLoading)
const factoryTypesLoading = useSelector(selectFactoryTypesLoading)
const workshopSearchResults = useSelector(selectWorkshopSearchResults)
const mtrSubtypes = [{name: "No MTR", value: false}, {name: "MTR", value: true}];
const vanRequestOptions = [{name: "Sí", value: true}, {name: "No", value: false}];
const compactAcceptOptions = ["Sí", "Sí provisional hasta entrega furgoneta", "No"];
const reasonOptions = ["Mecánica", "Chapa"];
const [shouldHideFields, setShouldHideFields] = useState(false);
const [shouldHideFieldsPool, setShouldHideFieldsPool] = useState(false);
const [shouldHideFieldsShortRent, setShouldHideFieldsShortRent] = useState(false);
const [shouldHideFieldsBag, setShouldHideFieldsBag] = useState(true);
const [disableCategoryField, setDisableCategoryField] = useState(false);






useEffect(()=>{
    dispatch(getTaxonomyTemplates({query: "?templateCode=" + template?.code}))   
},[])

useEffect(()=>{
    if(factoryActive){
       provincesWithOfficesLoading !== "succeeded" && dispatch(getFactoryProvincesWithOffices());
       provincesLoading !== "succeeded" && dispatch(getFactoryProvinces())
       rentTypesLoading !== "succeeded" && dispatch(getFactoryRentTypes());
       channelsLoading  !== "succeeded" && dispatch(getFactoryChannels());
       categoriesLoading !== "succeeded" && dispatch(getFactoryCategories());
       factoryTypesLoading !== "succeeded"  && dispatch(getFactoryTypes());
       dispatch(getFactoryBranches({query:`?plate=${plate}&CustomerCode=${customerCode}`})) 
    }

    },[])

useEffect(()=>{
    if(branches.length > 0){
        onChange("branch", branches[0].description)
    }
},[branches])

function setNotes(e){
    const filteredText = deleteStrangeCharacters(e.value); 
    onChange("notes", filteredText)
   
}
function changeDate(field, date){
    let stringDate = null; 
    if(date){
    stringDate = dayjs(date).format()
    }
    onChange(field,stringDate)
}

function setPhoneNumber(e){
    let nonDigitsRegExp = /\D/gm;
    const filteredNumber = e.value.replace(nonDigitsRegExp, "")
    onChange("phoneNumber", filteredNumber)
}

useEffect(()=>{
    if(type && types.length > 0){
    onChange("templateId", getTemplateIdFromCode(type))
    }
},[type, types])

function getProvinceOptionsByType(type){
    switch(type){
        case SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE:
            return provincesWithOffices
        case SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_RETURN:
            return allProvinces
    }
}

function getCityOptionsByType(type){
    switch(type){
        case SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE:
            return cities;
        case SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_RETURN:
            return allCities; 
    }
}

function getTemplateIdFromCode(code){
    const result = types.find(type=> type.code === code)
    if(result){
        return result.id
    }
}

function changeReasignation(value){
    onChange("reasignation",value)
}

function groupDateUntil(date){
    if(!date)
        return null;
    const parsedDate = dayjs(date, "DD/MM/YYYY H:mm:ss")
    return parsedDate.isValid() ? parsedDate.format("DD/MM/YYYY") : null
}


useEffect(()=>{
    let schedules = {};
    if(dataForm.office){
        const office = officesByCity.find(x => x.officeInfo.officeName === dataForm.office);
        if(office) schedules = office.officeInfo
    }
    setOfficeSchedules({...schedules});

},[dataForm?.office])

useEffect(()=>{
    if(dataForm?.rentType){
        setDisableCategoryField(false);
        let rentType = dataForm?.rentType.toLowerCase();

        if(!rentType.includes("ilimitado")){
            dispatch(getFactoryCategories());
        }
        
        if(rentType.includes("pool") || rentType.includes("bolsa") || rentType.replace('í','i').includes("dias")){
            setShouldHideFieldsShortRent(false)
            setShouldHideFields(false);
            setShouldHideFieldsBag(false);
            setShouldHideFieldsPool(true);
        }
        else if(rentType.includes("ilimitado") || rentType.includes("bankia") || rentType.includes("cliente") || rentType.includes("diferencia")){
            setShouldHideFieldsPool(false);
            setShouldHideFieldsShortRent(false)
            setShouldHideFields(true);
            setShouldHideFieldsBag(true);

            if(rentType.includes("ilimitado")){
                dispatch(getFactoryCategoriesSVUnlimited({query:`?plate=${plate}`})).then((data) => {
                    if(data.payload && data.payload.length > 0){
                        onChange("category",data.payload[0].description);
                    }else{
                      dispatch(openModal({ type: "warning", message: "La matrícula del caso no posee contratado vehículo de sustitución ilimitado"}))
                      onChange("category",null);
                    }
                    setDisableCategoryField(true);
                  });
            }
        }
        else if(rentType.includes("corto")){
            setShouldHideFieldsPool(false);
            setShouldHideFields(false);

            setShouldHideFieldsShortRent(true);
            setShouldHideFieldsBag(true);
        }else{
            setShouldHideFieldsPool(false);
            setShouldHideFields(false);
            setShouldHideFieldsShortRent(false); 
            setShouldHideFieldsBag(true);
        }
    }

},[dataForm?.rentType])


useEffect(()=>{
    if(dataForm?.rentType)
    {
        let rentType = dataForm?.rentType.toLowerCase();
        if(rentType.includes("bolsa"))
        {
            dispatch(getFactoryModalityBag({query:`?CustomerCode=${customerCode}`}))
                .then(
                    action => onChange("groups", action.payload)
                )
        }
        else if(rentType.includes("pool"))
        {
            dispatch(getFactoryModalityPool({query:`?Plate=${plate}`}))
                .then(
                    action => onChange("groups", action.payload)
                )
        }
        else if(rentType.replace('í','i').includes("dias"))
        {
            dispatch(getFactoryModalityTypeDaysYear({query:`?Plate=${plate}`}))
                .then(
                    action => onChange("groups", action.payload)
                )
        } else {
            onChange("groups", null)
        }
    }

},[dataForm?.rentType])

function handleChangeProvince(newValue){
    onChange("province", newValue)
    if(newValue !== null){
            const provinceId = allProvinces.find(factoryProvince=> factoryProvince.description === newValue).id; 
            if(type === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE){
                dispatch(getFactoryOfficesByProvinceId({query: `?provinceId=${provinceId}`}));
            } else if (type === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_RETURN){
                dispatch(getFactoryCities({query: `?provinceId=${provinceId}`}));
            }
           
            onChange("city", null)
            onChange("office", null)
    }
}

function handleChangeCity(newValue){

    onChange("city", newValue)

    if(factoryActive){
        if(newValue && type === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE){
            const cityId = cities.find(factoryCity=> factoryCity.description === newValue).id; 
            dispatch(getFactoryOfficesByCityId({query:`?cityId=${cityId}`}))
            onChange("office", null)
        }
    }
}

function handleChangeType(newValue){
    setType(newValue)
    onChange("templateCode", newValue)
    if(dataForm?.province){
        onChange("province", null)
        onChange("city", null)
        onChange("office", null)
    }
}

    return(
        <div className={classes.containers} id="documentation-request-form">
                    <SelectBox label="Tipología" disabled={typesLoading === "loading"} value={type} onValueChanged={(e) => handleChangeType(e.value)} valueExpr={"code"} displayExpr="name" placeholder="" dataSource={types} ></SelectBox>     
                    <>
                    {type === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_RETURN &&
                            <TextBox label={"Matrícula a devolver"} maxLength={50} key={"returnPlate"} name="returnPlate" value={dataForm?.returnPlate} onValueChanged={(e) => onChange("returnPlate", e.value)}  ></TextBox>
                    }
                    {  type === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE &&
                        <>
                            <div className="grid-four-columns">
                                <div className="template-checkbox-container">
                                    <CheckBox key={"reasignation"} name="reasignation" value={dataForm?.reasignation?dataForm?.reasignation:false} onValueChanged={(e) => changeReasignation(e.value)}></CheckBox>
                                    <label>Reasignación</label>  
                                </div>
                                {dataForm?.reasignation&&
                                <>
                                    <TextBox label="Matrícula entrante" labelMode="floating" key={"plateIn"} name="plateIn" value={dataForm?.plateIn} onValueChanged={(e) => onChange("plateIn",e.value)}  ></TextBox>
                                    <TextBox label={"Matrícula sustitución"} labelMode="floating" key={"plateSubstitution"} name="plateSubstitution" value={dataForm?.plateSubstitution} onValueChanged={(e) => onChange("plateSubstitution",e.value)}  ></TextBox>
                                    <TextBox label={"Matrícula salida"} labelMode="floating" key={"plateOut"} name="plateOut" value={dataForm?.plateOut} onValueChanged={(e) => onChange("plateOut",e.value)}  ></TextBox>                  
                                </>
                                } 
                            </div>      
                                <div className={factoryActive? classes.branch_wrapper : classes.branch_wrapper_disabled}>
                                    {dataForm?.branch}   
                            </div>
                        </>
                    }
                    {type !== SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_OTHER &&
                        <>
                        <div className={type === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_RETURN ? "grid-three-columns" : "grid-two-columns"}>
                            {type === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_RETURN &&
                            <TextBox label={"Código postal"} labelMode="floating" maxLength={5} key={"postalCode"} name="postalCode" value={dataForm?.postalCode} onValueChanged={(e) => onChange("postalCode", e.value)}  ></TextBox>
                            }                        
                            {factoryActive || ( !factoryActive && type !== SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_RETURN)?
                                <SelectBox label="Provincia" disabled={!type || !factoryActive} searchEnabled key={"province"} name="province" valueExpr={"description"} displayExpr="description" value={dataForm?.province}   onValueChanged={(e)=>handleChangeProvince(e.value)} placeholder="" dataSource={getProvinceOptionsByType(type)} ></SelectBox>
                                : <TextBox label="Provincia" labelMode="floating" key={"province"} name="province" value={dataForm?.province} onValueChanged={(e) => onChange("province",e.value)}  ></TextBox>
                            }
                            {factoryActive || ( !factoryActive && type !== SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_RETURN)?
                                <SelectBox 
                                    label={"Localidad"}
                                    searchEnabled 
                                    disabled={!dataForm?.province || !factoryActive} 
                                    valueExpr={"description"} 
                                    displayExpr={"description"}
                                    key={"city"} 
                                    name="city" 
                                    value={dataForm?.city} 
                                    onValueChanged={(e) => handleChangeCity(e.value)} 
                                    dataSource={getCityOptionsByType(type)}
                                    placeholder=""
                                    itemRender={(item)=><div className={classes.custom_item_factory}>{item.description}</div>}
                                    >
                                    </SelectBox>
                                    : <TextBox label={"Localidad"} labelMode="floating" key={"city"} name="city" value={dataForm?.city} onValueChanged={(e) => onChange("city",e.value)}  ></TextBox>
                            }
                        </div>
                        </>
                        }
                        {type === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE &&
                        <>
                                <SelectBox 
                                    label={"Oficina"}
                                    value={dataForm?.office}
                                    valueExpr={"officeInfo.officeName"} 
                                    displayExpr="officeInfo.officeName" 
                                    onValueChanged={(e) => onChange("office",e.value)} 
                                    placeholder="" 
                                    dataSource={officesByCity} 
                                    disabled={!dataForm?.city || !factoryActive}
                                    noDataText="No hay oficinas para la localidad seleccionada"
                                    itemRender={(item)=><div className={classes.custom_item_factory}>{item.officeInfo.officeName}</div>}
                                >
                                </SelectBox>
                            <div className={"grid-three-columns"}>
                                    <TextBox label={"Horario Lunes a Viernes"} labelMode="floating" disabled={!factoryActive}  key={"weekdaySchedule"} name="weekdaySchedule" value={officeSchedules.weekdaySchedule}  ></TextBox>
                                    <TextBox label={"Horario Sábado"} labelMode="floating" disabled={!factoryActive} key={"saturdaySchedule"} name="saturdaySchedule" value={officeSchedules.saturdaySchedule}  ></TextBox>
                                    <TextBox label={"Horario Domingo"} labelMode="floating" disabled={!factoryActive} key={"sundaySchedule"} name="sundaySchedule" value={officeSchedules.sundaySchedule}  ></TextBox>
                            </div>
                        </>
                        }
                        {type !== SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE&&
                        <>
                            <div className={classes.input_grid}>
                                    <TextBox label={"Nome"} labelMode="floating" key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)}  ></TextBox>
                                    <TextBox label={"Apellidos"} labelMode="floating" key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)}  ></TextBox>
                            </div>
                            <div className={classes.input_grid}>                           
                                    <TextBox label={"Móvil"} labelMode="floating" key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}}  ></TextBox>
                                    <TextBox label={"Correo electrónico"} labelMode="floating" key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)}  ></TextBox>
                            </div>
                        </>}
                    </>
                {type === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE&&
                    <> 
                        <div className={classes.input_grid} style={{marginBottom: !shouldHideFieldsPool && !shouldHideFields ? 0 : 10}}>  
                                <SelectBox label={"Modalidad alquiler"} disabled={!factoryActive} value={dataForm?.rentType} onValueChanged={(e) => onChange("rentType",e.value)} valueExpr={"description"} displayExpr="description" placeholder="" dataSource={rentTypes} ></SelectBox>
                        {!shouldHideFieldsPool && !shouldHideFields &&
                                <SelectBox label={"Canal"} disabled={!factoryActive} value={dataForm?.channel} valueExpr={"description"} displayExpr="description" onValueChanged={(e) => onChange("channel",e.value)} placeholder="" dataSource={channels} ></SelectBox>
                        }
                        </div> 
                                    <SelectBox
                                        label={"Categoría"}
                                        disabled={!factoryActive} 
                                        readOnly={disableCategoryField}
                                        value={dataForm?.category} 
                                        valueExpr={"description"} 
                                        displayExpr="description"
                                        onValueChanged={(e) => onChange("category",e.value)} 
                                        placeholder="" 
                                        dataSource={categories} 
                                        itemRender={(item)=><div className={classes.custom_item_factory}>{item.description}</div>}
                                        >
                                        </SelectBox>
                        {!shouldHideFieldsPool && !shouldHideFieldsShortRent &&
                            <div className={classes.input_grid}>       
                                <SelectBox label="Tipo" disabled={!factoryActive} value={dataForm?.typeInfo} valueExpr={"description"} displayExpr="description" onValueChanged={(e) => onChange("typeInfo",e.value)} placeholder="" dataSource={typesInfo} ></SelectBox>
                                <SelectBox label={"Motivo"} value={dataForm?.reason} onValueChanged={(e) => onChange("reason",e.value)} placeholder="" dataSource={reasonOptions} ></SelectBox>
                            </div>
                        }   
                        <div className={classes.input_grid}>         
                                <DateBox label={"Fecha y hora"} displayFormat={"dd/MM/yyyy HH:mm"} applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"date"} name="date" type="datetime" value={dataForm?.date} onValueChanged={(e) => changeDate("date", e.value)}  ></DateBox>
                                <TextBox label={"Duración (días)"} labelMode="floating" key={"duration"} maxLength={9} name="duration" value={dataForm?.duration}onValueChanged={(e) => onChange("duration",e.value)}   ></TextBox>     
                        </div> 
                        {!shouldHideFieldsBag && groups.length > 0 &&
                            <div style={{fontSize: "1rem", }}>
                                <div className={"bag-groups-table-grid"} style={{borderBottom: "1px solid black", fontWeight: 700}}>
                                    <div>Grupo</div> <div>Días disponibles</div> <div>Fecha hasta</div>
                                </div>
                                {groups.map((group, index)=>
                                        <div className={"bag-groups-table-grid"} key={`${group.secondaryDescription}-${index}`}>
                                            <TextBox readOnly name="group" value={group.secondaryDescription} onValueChanged={(e) => onChange("group",e.value)}  ></TextBox>
                                            <TextBox readOnly style={{textAlign: "right"}} name="avaliableDays" value={group.description} onValueChanged={(e) => onChange("avaliableDays",e.value)}  ></TextBox>
                                            <TextBox readOnly style={{textAlign: "right"}} name="dateUntil" value={groupDateUntil(group.tertiaryDescription)} onValueChanged={(e) => onChange("dateUntil",e.value)}  ></TextBox>
                                        </div>
                                )}
                             </div>
                        }
                        <div>
                            <div>Dados contato</div> 
                            <Divider orientation="horizontal"></Divider>
                        </div>                       
                        <div className="grid-two-columns">
                                <TextBox label={"Nome"} labelMode="floating" key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)}  ></TextBox>
                                <TextBox label={"Apellidos"} labelMode="floating" key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)}  ></TextBox>                        
                                <TextBox label={"Móvil"} labelMode="floating" key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}}  ></TextBox>
                                <TextBox label={"Correo electrónico"} labelMode="floating" key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)}  ></TextBox>             
                        </div>
                            <div>
                                <div>Dados condutor</div> 
                                <Divider orientation="horizontal"></Divider>
                            </div>
                            <div className="grid-two-columns">
                                <TextBox label={"Nome"} labelMode="floating" key={"driverName"} name="driverName" value={dataForm?.driverName} onValueChanged={(e) => onChange("driverName",e.value)}  ></TextBox>
                                <TextBox label={"Apellidos"} labelMode="floating" key={"driverSurname"} name="driverSurname" value={dataForm?.driverSurname} onValueChanged={(e) => onChange("driverSurname",e.value)}  ></TextBox>                        
                                    <TextBox label={"DNI"} labelMode="floating" value={dataForm?.dni} onValueChanged={(e) => onChange("dni",e.value)}  />
                                    <TextBox label={"Correo electrónico"} labelMode="floating" key={"driverEmail"} name="driverEmail" value={dataForm?.driverEmail} onValueChanged={(e) => onChange("driverEmail",e.value)}  ></TextBox>                         
                            </div>
                            <div>  
                                    <TextBox label={"Conductores adicionales"} labelMode="floating" key={"additionalDrivers"} name="additionalDrivers" value={dataForm?.additionalDrivers} onValueChanged={(e) => onChange("additionalDrivers",e.value)}  ></TextBox>
                            </div>
                        
                        {!shouldHideFieldsPool && !shouldHideFieldsShortRent &&                         
                            <SelectBox disabled={!workshopSearchResults} placeholder=" " label={"Taller"} key={"workshop"} name="workshop" value={dataForm?.workshop} onValueChanged={(e) => onChange("workshop",e.value)} dataSource={workshopSearchResults} displayExpr={"name"} className={classes.controlers}  />
                        }
                        <div className="grid-two-columns">                           
                            <SelectBox label={"Solicita furgoneta"} labelMode="floating" key={"vanRequest"} name="vanRequest" valueExpr={"value"} displayExpr="name" value={dataForm?.vanRequest}   onValueChanged={(e) => { onChange("vanRequest", e.value)}} placeholder="" dataSource={vanRequestOptions}></SelectBox>
                        {!shouldHideFieldsPool && !shouldHideFields &&
                            <SelectBox label={"MTR"} labelMode="floating" searchEnabled key={"mtr"} name="mtr" valueExpr={"value"} displayExpr="name" value={dataForm?.mtr}   onValueChanged={(e) => { onChange("mtr", e.value)}} placeholder="" dataSource={mtrSubtypes} ></SelectBox>
                        }
                        </div>
                        {dataForm?.vanRequest &&
                        <div className="grid-two-columns">
                            <TextBox label={"Nº plazas solicitadas"} labelMode="floating" key={"placesNumber"} maxLength={9} name="placesNumber" value={dataForm?.placesNumber} onValueChanged={(e) => onChange("placesNumber",e.value)}   ></TextBox>
                            <SelectBox label={"Acepta compacto"} value={dataForm?.compactAccept} onValueChanged={(e) => onChange("compactAccept",e.value)} placeholder="" dataSource={compactAcceptOptions} ></SelectBox>
                        </div>
                        }
                    </>  
                }
                {type === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_RETURN &&
                    <div className="grid-two-columns">                           
                            <TextBox label={"Calle"} labelMode="floating" key={"address"} name="address" value={dataForm?.address} onValueChanged={(e) => onChange("address",e.value)}  ></TextBox>
                            <TextBox label={"Número"} labelMode="floating" maxLength={10} key={"streetNumber"} name="streetNumber" value={dataForm?.streetNumber} onValueChanged={(e) => onChange("streetNumber",e.value)}  ></TextBox>
                    </div>
                }
            <TextArea label={"Notas"} labelMode="floating" key={"notes"} name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)} height={144}></TextArea>
        </div>
    )
}

export { SubstitutionVehicleRequestForm }